import ModelListCommon from "./ModelListCommon";

import ModelCollectionTournament  from "./common/model/ModelCollectionTournament"
import TournamentConnector  from "./common/connectors/TournamentConnector"
import Game from "./common/model/Types/Game";
import Tournament from "./common/model/Types/Tournament";
import ArraySortedTournament from "./ArraySortedTournament";



export default class ModelListTournament extends ModelListCommon {

    models:ModelCollectionTournament
    connector:TournamentConnector
    modelsSorted:ArraySortedTournament
    

    constructor(userConnector:any ) {           
        super(userConnector);
        this.models = new ModelCollectionTournament();
        this.connector = new TournamentConnector(this.socket);     
        this.modelsSorted = new ArraySortedTournament(this.models);    
                               
        this.connector.setCallbackTournamentChanged( (data) => {
            if(!this.filled)           
                return;
                
            this.models.itemUpdate(data.tournament);
            this.onListChanged();             
        });      
    }

    getEventData():any {
        return this.modelsSorted;
    }

    getConnector():TournamentConnector {
        return this.connector;
    }
            
    async doDataClear() {  
        super.doDataClear();      
        this.models.clear();
        this.onListChanged();
    }    

    async doDataFetch() {             
        super.doDataFetch(); 

        let result;
        this.models.clear();
        let modified = false;
                
        result = await this.connector.doGetListSearch({ status: "actual"}, {page:0, pageSize:20});         
        this.models.itemUpdateArray(result.models);
        modified = modified || result.models.length > 0;
               
        if(modified)
            this.onListChanged();     
    }

    onListChanged() {        
        this.modelsSorted.update(this.models, <string>this.playerUuid);
        this.emit(ModelListCommon.EVENT_DATA_CHANGED, this.getEventData());
    }
}
